import React from 'react'
import {Link} from 'react-router-dom'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import GameProducer from '../components/GameProducer'
import headerImageMobile from '../assets/imgs/Mystino-home-m.jpg'
import headerLoginImage from '../assets/imgs/Mystino-home-test.jpg'
import headerRegisterImage from '../assets/imgs/Mystino-home.jpg'
import {Helmet} from "react-helmet";
import games from '../assets/social-games';

const gameProducers = [
    {
        image: require('../assets/imgs/game_producers/netent.png'),
        title: 'NETENT',
        link: '/netent'
    },
    {
        image: require('../assets/imgs/game_producers/yggdrasil-gaming.png'),
        title: 'Evolution Gaming',
        link: '/evolution'
    },
    {
        image: require('../assets/imgs/game_producers/jtg-logo.png'),
        title: 'JTG',
        link: '/jtg'
    },
    {
        image: require('../assets/imgs/game_producers/playgo.png'),
        title: "Play'n Go",
        link: '/playgo'
    },
    {
        image: require('../assets/imgs/game_producers/microgaming.png'),
        title: 'Blaze of Ra',
        link: 'blazeofra'
    }
]

class TestPage extends React.Component {
    owlCarouselOptions = {
        items: 5,
        margin: 5,
        stagePadding: 20,
        nav: false,
        rewind: true,
        autoplay: true,
        responsive: {
            0: {
                items: 2,
                nav: true
            },
            720: {
                items: 2,
                nav: true
            },
            1000: {
                items: 5,
                nav: true
            },
        },
    }

    constructor(props) {
        super(props);

        this.state = {
            limit: 25,
            showLoadMoreButton: true,
            numberOfGames: 0,
            gameList: games,
            matches: window.matchMedia("(max-width: 768px)").matches
        }
        this.loadMore = this.loadMore.bind(this);
    }

    componentDidMount() {
        let newGames = [];

        games.map((game, indexGame) => {
            const gamesCanPlay = ["hawaiian_dream.goldenhero",
                "baccarat.netent",
                "golden_chip_roulette.yggdrasil",
                "magic_maid_cafe.netent",
                "casino_holdem.netent",
                "dreams_of_gold.goldenhero",
                "oiran_dream.goldenhero",
                "vikings_go_berzerk.yggdrasil",
                "battle_dwarf.goldenhero",
                "blackjack_multi_hand.concept",
                "blackjack.netent",
                "lucky_neko.yggdrasil",
                "starburst.netent",
                "european_roulette.netent",
                "bonanza_megaways.btg",
                "money_train_2.relax",
                "american_roulette.netent",
                "super_elephant.skywind",
                "razor_shark.push",
                "reactoonz.playngo",
                "french_roulette.netent",
                "white_rabbit.btg",
                "gonzos_quest.netent",
                "koi_princess.netent",
                "dead_or_alive.netent",
            ];
            let canPlay = false;

            if (gamesCanPlay.includes(game.id)) {
                canPlay = true;
            }

            newGames.push({
                id: game.id,
                name: game.name,
                image: game.thumbnailUrl,
                metaTitle: game.metaTitle,
                shortDescription: game.shortDescription,
                canPlay: canPlay
            });
        })

        this.setState({
            gameList: newGames,
        });
    }

    loadMore = (e) => {
        e.preventDefault();

        if (this.state.limit + 25 >= this.state.gameList.length) {
            this.setState({showLoadMoreButton: false})
        }

        this.setState({limit: this.state.limit + 25})
    }

    //helpere
    showGames = (playAllGames) => {
        return this.state.gameList.slice(0, this.state.limit).map((game, index) => {
            let link;
            let gameBlur = '';

            if (playAllGames !== true) {
                if (game.canPlay === true) {
                    link = <Link to={`/game/` + game.id} className="play2 button">Play</Link>
                } else {
                    if (localStorage['isReturnVisitor']) {
                        link = <div className='div-homepage-register'><a className='button-register'
                                                                         onClick={this.props.showLoginModal}>ログインしてプレイ</a>
                        </div>
                    } else {
                        link = <div className='div-homepage-register'><a className='button-register'
                                                                         onClick={this.props.showModal}>新規登録してプレイ</a>
                        </div>
                    }

                    gameBlur = 'game-blur'
                }
            } else {
                link = <Link to={`/game/` + game.id} className="play2 button">Play</Link>
            }


            return (
                <div key={index}>
                    {(playAllGames !== false || game.canPlay === true) ?
                        <div className='game__card'>
                            <div className="game-text">今すぐプレイ</div>
                            <Link to={`/game/` + game.id} className='game-card-link'>
                                <img className={"game__card--image " + gameBlur}
                                     src={require("../assets/imgs/games_imgs/" + game.id + ".jpeg")} alt=''/>
                                <p className='game__card--title'>{game.name}</p>
                            </Link>
                            <p className='game__card--subtitle'>{game.shortDescription}</p>
                            {link}
                        </div>
                        : <div className='game__card'>
                            <img className={"game__card--image " + gameBlur}
                                 src={require("../assets/imgs/games_imgs/" + game.id + ".jpeg")} alt=''/>
                            <p className='game__card--title'>{game.name}</p>
                            <p className='game__card--subtitle'>{game.shortDescription}</p>
                            {link}
                        </div>}
                </div>

            )
        })
    }

    showGameProducers = () => {
        window.getSelection().empty()
        return gameProducers.map((elem, index) => (
            <GameProducer
                key={index}
                image={elem.image}
                link={elem.link}
            />
        ))
    }

    render() {

        let contentGames = "";
        let playAllGames = false;
        let headerImage = headerRegisterImage;
        let CtaHeader = <a className="button-register" onClick={this.props.showModal}>新規登録はこちら</a>
        let showMoreContent = <div className="text-center">
            <a href='#' onClick={this.loadMore} className='slideshow__container--button'>
                すべてのゲームを見る
            </a>
        </div>;

        if (this.props.currentUser) {
            playAllGames = true;
        }
        contentGames = this.showGames(playAllGames);
        // if (this.state.gameListStatus === apiStatus.fetching || this.state.gameListStatus === apiStatus.notFetched) {
        //     contentGames = <div className="loading">Loading...</div>;
        // } else if (this.state.gameListStatus === apiStatus.fetched) {
        //     contentGames = this.showGames(playAllGames);
        // } else if (this.state.gameListStatus === apiStatus.hasError) {
        //     contentGames = <div>An error has occured. {this.state.errorMessage}</div>;
        // }

        if (!this.state.showLoadMoreButton) {
            showMoreContent = "";
        }

        if (localStorage['isReturnVisitor']) {
            headerImage = headerLoginImage;
            CtaHeader = <a className="button-register" onClick={this.props.showLoginModal}>ログイン</a>
        }
        if (this.state.matches) {
            headerImage = headerImageMobile
        }

        return (
            <div className='homepage__container'>
                <Helmet>
                    <title>ミスティーノFREE | 無料オンラインカジノゲーム</title>
                </Helmet>

                {!this.props.currentUser &&
                <div className='slideshow__container'>
                    <div className="col-md-12 bg-img-home" onClick={this.props.showLoginModal}
                         style={{backgroundImage: `url(${headerImage})`}}></div>
                    {/*<div className="col-md-6 bg-img-home-right">*/}
                    {/*<div className="ml-50">*/}
                    {/*<h1>無料で遊べる! <br/> オンラインカジノ</h1>*/}
                    {/*<div className="row row-header">*/}
                    {/*<div className="col-4 col-sm-4 col-md-4">*/}
                    {/*<p>全ゲームが <br/> 完全無料</p>*/}
                    {/*<img src={homeSign}/>*/}
                    {/*</div>*/}
                    {/*<div className="col-4 col-sm-4 col-md-4">*/}
                    {/*<p>途中課金 <br/> 一切なし</p>*/}
                    {/*<img src={homeSign}/>*/}
                    {/*</div>*/}
                    {/*<div className="col-4 col-sm-4 col-md-4">*/}
                    {/*<p>ゲーム数は <br/> 50種類超</p>*/}
                    {/*<img src={homeSign}/>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="row">*/}
                    {/*<div className="col-md-12 text-left">*/}
                    {/*{CtaHeader}*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*</div>*/}

                    {/*</div>*/}

                </div>
                }

                <div className='game__container'>
                    {contentGames}
                </div>
                {showMoreContent}
                <div className='gameproducers__container'>
                    <p className='gameproducers__container--title'>ゲームプロバイダー</p>
                    <OwlCarousel className='owl-theme' {...this.owlCarouselOptions}>
                        {this.showGameProducers()}
                    </OwlCarousel>
                </div>
                <div className='d-flex flex-wrap'>
                    <div className="home-text-container col-sm-12 col-md-6 col-lg-6">
                        <div className="home-text">
                            <h1>ミスティーノ無料カジノゲーム</h1>
                            <p>無料でのカジノゲームはお好きですか？そんなあなたにぴったり！いつでもどこでも遊びたいときに、お気に入りのカジノゲームをミスティーノでプレイすることができます。PCでもスマホでもタブレットでも、どれでもOK。ミスティーノのアプリをダウンロードして、遊びたいゲームをお好きなところでお好きなときにプレイしましょう！</p>
                            <p>ミスティーノカジノゲームを無料でプレイするのはとてもシンプルで簡単。たくさんのゲームの中から好きなゲームを選んでプレイするだけ！ミスティーノは日本人プレイヤーが遊びやすいようにデザインされており、素晴らしいゲーム体験があなたを待っています。いつでもどこでも楽しめます！</p>
                            <p>魔法の世界ミスティーノで、お気に入りのカジノゲームを無料で遊ぼう！始めるなら今がベスト。今すぐプレイ！</p>
                        </div>
                    </div>
                    <div className="home-image col-sm-12 col-md-6 col-lg-6">
                        <img
                            className='chest-image'
                            src={require('../assets/imgs/treasure-test.png')}
                            alt=''
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default TestPage
